import abi from "./contract/GlobalPool.json";
import { useState, useEffect } from "react";
import { ethers } from "ethers";
import Buy from "./component/buy";
import Buy1 from "./component/buy1";
import Memos from "./component/memos";
import "./copy.png";
import Buy3 from "./component/buy3";

function App() {
  const [state, setState] = useState({
    provider: null,
    signer: null,
    contract: null,
  });

  const [account, setAccount] = useState("None");
  const [b, setB] = useState("None");
  const [direct, setDirect] = useState("None");
  const [directs, setDirects] = useState("None");
  const [level, setLevel] = useState("None");
  const [wlevel, setLevelw] = useState("None");
  const [level1, setLevel1] = useState("None");
  const [wlevel1, setLevelw1] = useState("None");
  const [plevel, setLevelp] = useState("None");
  const [pack, setpackage] = useState("None");
  const [pack3, setpackage3] = useState("None");
  const [pack1, setpackage1] = useState("None");
  const [refer, setrefer] = useState("None");
  const [refer4, setrefer4] = useState("None");
  const [refer3, setrefer3] = useState("None");
  const [refer1, setrefer1] = useState("None");
  const [refer2, setrefer2] = useState("None");
  const [tasks, setTasks] = useState([]);
  const [tasks1, setTasks1] = useState([]);
  const [tt, settt] = useState("None");
  const [tt4, settt4] = useState("None");
  const [dd, setDD] = useState("None");
  const [dd1, setDD1] = useState("None");
  const [dd2, setDD2] = useState("None");
  const [referlink, setreflink] = useState("None");
  const [bonanza, setBonanza] = useState("None");
  const [upd, setupd] = useState("None");
  const [tt1, settt1] = useState("None");
  const [roi, seroi] = useState("None");
  const [roi1, seroi1] = useState("None");
  const [roi2, seroi2] = useState("None");
  const [a1, sea1] = useState("None");
  const [a2, sea2] = useState("None");
  const [a3, sea3] = useState("None");
  const [tt2, settt2] = useState("None");
  const [tt3, settt3] = useState("None");
  const [b1, setb1] = useState("None");
  const [b2, setb2] = useState("None");
  const [b3, setb3] = useState("None");
  const [b4, setb4] = useState("None");
  const [b5, setb5] = useState("None");
  const [b6, setb6] = useState("None");
  const [b7, setb7] = useState("None");
  const [b8, setb8] = useState("None");
  const [b9, setb9] = useState("None");
  const [b10, setb10] = useState("None");
  const [b11, setb11] = useState("None");
  const [b12, setb12] = useState("None");
  const [b13, setb13] = useState("None");
  const [b14, setb14] = useState("None");
  const [b15, setb15] = useState("None");
  const [b16, setb16] = useState("None");
  const [reward, setreward] = useState("None");
  const [reward1, setreward1] = useState("None");
  const [reward2, setreward2] = useState("None");
  const [reward3, setreward3] = useState("None");
  const [reward4, setreward4] = useState("None");
  const [reward5, setreward5] = useState("None");
  const [reward6, setreward6] = useState("None");
  const [reward7, setreward7] = useState("None");
  const [reward8, setreward8] = useState("None");
  const [reward9, setreward9] = useState("None");
  const [reward10, setreward10] = useState("None");

  const [x1, setx1] = useState("None");
  const [x2, setx2] = useState("None");
  const [x3, setx3] = useState("None");
  const [x4, setx4] = useState("None");

  useEffect(() => {
    const connectWallet = async () => {
      const contractAddress = "0x43ba2262419fdd4edf2ecb9aa0a2f2e4e4ad04de";
      const contractABI = abi.abi;
      const searchParams = new URLSearchParams(window.location.search);
      const myParam = searchParams.get("ref");
      console.log(myParam);
      document.querySelector("#name").value = myParam;
      document.querySelector("#refer").value = myParam;

      const { ethereum } = window;
      //  document.querySelector("#test").value = "0";

      const account = await ethereum.request({
        method: "eth_requestAccounts",
      });

      window.ethereum.on("chainChanged", () => {
        window.location.reload();
      });

      window.ethereum.on("accountsChanged", () => {
        window.location.reload();
      });
      const provider = new ethers.providers.Web3Provider(ethereum);

      try {
        const selectedNetwork = await provider.getNetwork();

        if (selectedNetwork.chainId !== 56) {
          await window.ethereum.request({
            method: "wallet_switchEthereumChain",
            params: [{ chainId: "0x38" }], // Binance Smart Chain Mainnet chainId is 97 in decimal, which is 0x61 in hex
          });
          console.log("You have switched to the Binance network");
        } else {
          console.log("You are already on the Binance network");
        }
      } catch (switchError) {
        // The network has not been added to MetaMask
        if (switchError.code === 4902) {
          console.log("Please add the Binance network to MetaMask");
        } else {
          console.log("Cannot switch to the network");
        }
      }

      const signer = provider.getSigner();
      const contract = new ethers.Contract(
        contractAddress,
        contractABI,
        signer
      );
      setAccount(account);
      setState({ provider, signer, contract });
      document.querySelector("#us").value = account[0];
      let alltasks = await contract.getMemos(account[0]);
      setTasks(alltasks);
      var i = 0;
      const refer = alltasks[1];
      setrefer(refer);
      const a1 = alltasks[13];
      sea1(a1);
      const refer2 = alltasks[23];
      setrefer2(refer2);
      const x4 = Number(alltasks[22]) / 1000000000000000000;
      setx4(x4);
      const b = Number(alltasks[2]);

      document.querySelector("#hid").value = alltasks[1];
      const direct = Number(alltasks[2]);
      setDirect(direct);
      const level = Number(alltasks[4]);
      setLevel(level);

      const plevel = Number(alltasks[21]) / 1000000000000000000;
      setLevelp(plevel);

      const pack = Number(alltasks[3]);

      setpackage(pack);

      document.querySelector("#pp").value = Number(alltasks[3]);

      setB(b);

      const dd = Number(alltasks[9]);

      setDD(dd);

      const reward1 = Number(alltasks[11]) / 1000000000000000000;

      setreward1(reward1);

      const reward2 = Number(alltasks[17]) / 1000000000000000000;

      setreward2(reward2);
      const reward3 = Number(alltasks[18]) / 1000000000000000000;

      setreward3(reward3);

      const reward4 = Number(alltasks[23]) / 1000000000000000000;
      setreward4(reward4);
      const reward5 = Number(alltasks[27]);
      setreward5(reward5);

      const reward6 = Number(alltasks[28]);
      setreward6(reward6);

      const reward7 = Number(alltasks[29]);
      setreward7(reward7);

      const x1 = Number(alltasks[17]) / 1000000000000000000;
      setx1(x1);
      const x2 = Number(alltasks[18]) / 1000000000000000000;
      setx2(x2);
      const x3 = Number(alltasks[19]) / 1000000000000000000;
      setx3(x3);

      const dd2 = Number(alltasks[27]);

      setDD2(dd2);

      const dd1 = Date.now() / 1000;
      setDD1(dd1);

      const tt1 = Math.trunc((dd1 - dd) / (3660 * 24));
      //  const tt1 =  (dd1.getTime() - dd.getTime())/ (1000 * 60 * 60 * 24);

      settt1(tt1);

      const tt2 = Math.trunc((dd1 - dd2) / 60);
      //  const tt1 =  (dd1.getTime() - dd.getTime())/ (1000 * 60 * 60 * 24);

      settt2(tt2);

      document.querySelector("#tt2").value = tt2;

      const b1 = Number(alltasks[5]);
      setb1(b1);
      const b2 = Number(alltasks[6]);
      setb2(b2);
      const b3 = Number(alltasks[7]);
      setb3(b3);
      const b4 = Number(alltasks[8]);
      setb4(b4);
      const b5 = Number(alltasks[9]);
      setb5(b5);
      const b6 = Number(alltasks[10]);
      setb6(b6);
      const b7 = Number(alltasks[25]);
      setb7(b7);

      const wlevel = Number(alltasks[25]) / 1000000000000000000;

      setLevelw(wlevel);
      const wlevel1 = Number(alltasks[15]) / 1000000000000000000;

      setLevelw1(wlevel1);
      const level1 = Number(alltasks[21]);

      setLevel1(level1);

      // document.querySelector("#wi1").value = roi2;

      // const a1 = Number(alltasks1[0])-1;

      // sea1(a1);
      // const a3 = Number(alltasks1[2])/1000000000000000000;

      //  sea3(a3);
      const a2 = Number(alltasks[24]);
      sea2(a2);
      var rr = 0;
      // const tt4 =  Number(alltasks[15])/1000000000000000000;
      // settt4(tt4);

      const pack1 = Number(alltasks[30]) / 1000000000000000000;
      setpackage1(pack1);
      const tt = Number(alltasks[16]) / 1000000000000000000;
      settt(tt);
      const tt3 = Number(alltasks[10]) / 1000000000000000000;
      settt3(tt3);
      document.querySelector("#bal").value = tt3;
      const referlink = "https://binox.xyz/?ref=" + account;
      setreflink(referlink);
      document.querySelector("#link").value = referlink;

      
      console.log(pack);
    };

    connectWallet();

    function myFunction() {
      var copyText = "hello";
      copyText.select();
      copyText.setSelectionRange(0, 99999); // For mobile devices

      // Copy the text inside the text field
      navigator.clipboard.writeText(copyText.valueOf);
    }
  }, []);

  // console.log(state);
  return (
    <div>
      <input type="hidden" id="link"></input>
      <input type="hidden" id="hid"></input>
      <input type="hidden" id="us"></input>
      <input type="hidden" id="pp"></input>
      <input type="hidden" id="tt2"></input>
      <input type="hidden" id="wi1"></input>
      <input type="hidden" id="roi"></input>
      <input type="hidden" id="bal"></input>

      <section class="services-one section-space">
        <div class="container">
          <div class="row gutter-y-50">
            <div class="col-xl-5 col-lg-6">
              <div class="services-one__content">
                
                <p
                  class="services-one__text wow fadeInUp"
                  data-wow-duration="1500ms"
                >
                  We build a fully automated crypto ecosystem that runs on smart
                  contracts, delivering transparent, instant, and secure
                  financial operations for every user.
                </p>
                <div
                  class="services-one__image wow fadeInUp"
                  data-wow-duration="1500ms"
                >
                  <div class="services-one__image__inner">
                    <div class="services-one__image__img">
                      <img
                        src="assets/images/services/service-1-1.jpg"
                        alt="service"
                      />
                    </div>
                  </div>
                  <div
                    class="services-one__image__shape services-one__image__shape--1"
                  ></div>
                  <div
                    class="services-one__image__shape services-one__image__shape--2"
                  ></div>
                </div>
              </div>
            </div>
            <div class="col-xl-7 col-lg-6">
              <div  class="services-one__inner">
                <div  class="services-one__services">
                  <div 
                    class="services-one__card "
                    data-wow-duration="1500ms"
                     style={{
    
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "25px",
  }}
                  >
                      <span class="services-one__card__icon">
                      <i class="icon-spiral-flower"></i> </span
                    >
                
                     
                    <div class="services-one__card__content">
                      <div class="services-one__card__text-box">
                        <h3 style={{fontSize:"2rem"}} class="services-one__card__title">
                        Enter Refer
                        </h3>
                        <p class="services-one__card__text">
                          <input
                          type="text"
                          id="refer"
                          class="form-control"
                          width={"100%"}
                        ></input>
                        </p>
                      </div>
                    </div>
                  </div>
                  
                   <div 
                    class="services-one__card "
                    data-wow-duration="1500ms"
                     style={{
    backgroundColor: "#181823",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "25px",
   
  }}
                  >
                    
                    <span class="services-one__card__icon">
                      <i class="icon-spiral-flower"></i> </span
                    >
                    <div class="services-one__card__content">
                      <div  class="services-one__card__text-box">
                        <h3 style={{fontSize:"2rem"}}  class="services-one__card__title">
                        Deposit
                        </h3>
                        <p class="services-one__card__text">
                           <input
                          type="text"
                          id="amt"
                          class="form-control"
                          width={"100px"}
                        ></input>
                        
                        <h3 >
                         
                      <Buy state={state} /></h3>
                        </p>
                      </div>
                    </div>
                  </div>
                  
                   <div 
                    class="services-one__card "
                    data-wow-duration="1500ms"
                     style={{
    backgroundColor: "#181823",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "25px",
  }}
                  >
                    <span class="services-one__card__icon">
                      <i class="icon-spiral-flower"></i> </span
                    >
                    <div class="services-one__card__content">
                      <div  class="services-one__card__text-box">
                        <h3 style={{fontSize:"2rem"}}  class="services-one__card__title">
                         Withdraw
                        </h3>
                        <p class="services-one__card__text">
                           <input
                          type="text"
                          id="test"
                          width={"100px"}
                          class="form-control"
                        ></input>
                        </p>
                         <h3  class="services-one__card__title">
                         <Buy3 state={state} /></h3>
                      </div>
                    </div>
                  </div>
                
                 <div  
                    class="services-one__card "
                    data-wow-duration="1500ms"
                     style={{
    backgroundColor: "#181823",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "25px",
  }}
                  >
                    <span class="services-one__card__icon">
                      <i class="icon-spiral-flower"></i> </span
                    >
                    <div class="services-one__card__content">
                      <div  class="services-one__card__text-box">
                        <h3 style={{fontSize:"2rem"}}  class="services-one__card__title">
                         Trade
                        </h3>
                        <h3  class="services-one__card__title">
                          <Buy1 state={state} />
                        </h3>
                      </div>
                    </div>
                  </div>
                   <div 
                    class="services-one__card "
                    data-wow-duration="1500ms"
                     style={{
    backgroundColor: "#181823",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "25px",
  }}
                  >
                    <span class="services-one__card__icon">
                      <i class="icon-spiral-flower"></i> </span
                    >
                    <div class="services-one__card__content">
                      <div  class="services-one__card__text-box">
                        <h3 style={{fontSize:"2rem"}}  class="services-one__card__title">
                          Next Trade In
                        </h3>
                        <p class="services-one__card__text">
                          {1440 - tt2} Minutes
                        </p>
                      </div>
                    </div>
                  </div>
                
                 <div  
                    class="services-one__card "
                    data-wow-duration="1500ms"
                     style={{
  backgroundColor: "#181823",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "25px",
  }}
                  >
                    <span class="services-one__card__icon">
                      <i class="icon-spiral-flower"></i> </span
                    >
                    <div class="services-one__card__content">
                      <div  class="services-one__card__text-box">
                        <h3 style={{fontSize:"2rem"}}  class="services-one__card__title">
                         My Investment
                        </h3>
                        <p class="services-one__card__text">
                          {pack} USDT
                        </p>
                      </div>
                    </div>
                  </div>
                
                 <div  
                    class="services-one__card "
                    data-wow-duration="1500ms"
                     style={{
    backgroundColor: "#181823",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "25px",
  }}
                  >
                    <span class="services-one__card__icon">
                      <i class="icon-spiral-flower"></i> </span
                    >
                    <div class="services-one__card__content">
                      <div  class="services-one__card__text-box">
                        <h3 style={{fontSize:"2rem"}}  class="services-one__card__title">
                         Direct Team
                        </h3>
                        <p class="services-one__card__text">
                          {direct}
                        </p>
                      </div>
                    </div>
                  </div>
                
                 <div 
                    class="services-one__card "
                    data-wow-duration="1500ms"
                     style={{
    backgroundColor: "#181823",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "25px",
  }}
                  >
                    <span class="services-one__card__icon">
                      <i class="icon-spiral-flower"></i> </span
                    >
                    <div class="services-one__card__content">
                      <div  class="services-one__card__text-box">
                        <h3 style={{fontSize:"2rem"}}  class="services-one__card__title">
                        Level Team
                        </h3>
                        <p class="services-one__card__text">
                          {level}
                        </p>
                      </div>
                    </div>
                  </div>
                
                 <div   
                    class="services-one__card "
                    data-wow-duration="1500ms"
                     style={{
    backgroundColor: "#181823",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "25px",
  }}
                  >
                    <span class="services-one__card__icon">
                      <i class="icon-spiral-flower"></i> </span
                    >
                    <div class="services-one__card__content">
                      <div  class="services-one__card__text-box">
                        <h3 style={{fontSize:"2rem"}}  class="services-one__card__title">
                          Team Business
                        </h3>
                        <p class="services-one__card__text">
                          {level1}
                        </p>
                      </div>
                    </div>
                  </div>
                
                 <div   
                    class="services-one__card "
                    data-wow-duration="1500ms"
                     style={{
    backgroundColor: "#181823",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "25px",
  }}
                  >
                    <span class="services-one__card__icon">
                      <i class="icon-spiral-flower"></i> </span
                    >
                    <div class="services-one__card__content">
                      <div  class="services-one__card__text-box">
                        <h3 style={{fontSize:"2rem"}} class="services-one__card__title">
                        Total Fund Value
                        </h3>
                        <p class="services-one__card__text">
                          {tt} USDT
                        </p>
                      </div>
                    </div>
                  </div>
                
                 <div  
                    class="services-one__card "
                    data-wow-duration="1500ms"
                     style={{
    backgroundColor: "#181823",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "25px",
  }}
                  >
                    <span class="services-one__card__icon">
                      <i class="icon-spiral-flower"></i> </span
                    >
                    <div class="services-one__card__content">
                      <div  class="services-one__card__text-box">
                        <h3 style={{fontSize:"2rem"}} class="services-one__card__title">
                         Total Team
                        </h3>
                        <p class="services-one__card__text">
                         {level + direct} 
                        </p>
                      </div>
                    </div>
                  </div>
                
                 <div   
                    class="services-one__card "
                    data-wow-duration="1500ms"
                     style={{
    backgroundColor: "#181823",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "25px",
  }}
                  >
                    <span class="services-one__card__icon">
                      <i class="icon-spiral-flower"></i> </span
                    >
                    <div class="services-one__card__content">
                      <div  class="services-one__card__text-box">
                        <h3 style={{fontSize:"2rem"}} class="services-one__card__title">
                        Personal Growth Income
                        </h3>
                        <p class="services-one__card__text">
                          {x1} USDT
                        </p>
                      </div>
                    </div>
                  </div>
                
                 <div  
                    class="services-one__card "
                    data-wow-duration="1500ms"
                     style={{
    backgroundColor: "#181823",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "25px",
  }}
                  >
                    <span class="services-one__card__icon">
                      <i class="icon-spiral-flower"></i> </span
                    >
                    <div class="services-one__card__content">
                      <div  class="services-one__card__text-box">
                        <h3 style={{fontSize:"2rem"}}  class="services-one__card__title">
                        Direct Bonus
                        </h3>
                        <p class="services-one__card__text">
                         {x2} USDT 
                        </p>
                      </div>
                    </div>
                  </div>
                
                 <div  
                    class="services-one__card "
                    data-wow-duration="1500ms"
                     style={{
    backgroundColor: "#181823",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "25px",
  }}
                  >
                    <span class="services-one__card__icon">
                      <i class="icon-spiral-flower"></i> </span
                    >
                    <div class="services-one__card__content">
                      <div  class="services-one__card__text-box">
                        <h3 style={{fontSize:"2rem"}} class="services-one__card__title">
                         Level Bonus
                        </h3>
                        <p class="services-one__card__text">
                          {x3} USDT
                        </p>
                      </div>
                    </div>
                  </div>
                
                 <div   
                    class="services-one__card "
                    data-wow-duration="1500ms"
                     style={{
    backgroundColor: "#181823",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "25px",
  }}
                  >
                    <span class="services-one__card__icon">
                      <i class="icon-spiral-flower"></i> </span
                    >
                    <div class="services-one__card__content">
                      <div  class="services-one__card__text-box">
                        <h3 style={{fontSize:"2rem"}} class="services-one__card__title">
                        TOTAL WITHDRAWL
                        </h3>
                        <p class="services-one__card__text">
                          {wlevel1} USDT
                        </p>
                      </div>
                    </div>
                  </div>
                
                 <div 
                    class="services-one__card "
                    data-wow-duration="1500ms"
                     style={{
    backgroundColor: "#181823",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "25px",
  }}
                  >
                    <span class="services-one__card__icon">
                      <i class="icon-spiral-flower"></i> </span
                    >
                    <div class="services-one__card__content">
                      <div  class="services-one__card__text-box">
                        <h3 style={{fontSize:"2rem"}} class="services-one__card__title">
                        Level 1 Business
                        </h3>
                        <p class="services-one__card__text">
                          {b1} USDT
                        </p>
                      </div>
                    </div>
                  </div>
                
                 <div  
                    class="services-one__card "
                    data-wow-duration="1500ms"
                     style={{
    backgroundColor: "#181823",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "25px",
  }}
                  >
                    <span class="services-one__card__icon">
                      <i class="icon-spiral-flower"></i> </span
                    >
                    <div class="services-one__card__content">
                      <div  class="services-one__card__text-box">
                        <h3 style={{fontSize:"2rem"}} class="services-one__card__title">
                        Level 2 Business
                        </h3>
                        <p class="services-one__card__text">
                          {b2} USDT
                        </p>
                      </div>
                    </div>
                  </div>
                
                 <div  
                    class="services-one__card "
                    data-wow-duration="1500ms"
                     style={{
    backgroundColor: "#181823",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "25px",
  }}
                  >
                    <span class="services-one__card__icon">
                      <i class="icon-spiral-flower"></i> </span
                    >
                    <div class="services-one__card__content">
                      <div  class="services-one__card__text-box">
                        <h3 style={{fontSize:"2rem"}} class="services-one__card__title">
                        Level 3 Business
                        </h3>
                        <p class="services-one__card__text">
                          {b3} USDT
                        </p>
                      </div>
                    </div>
                  </div>
                
                 <div 
                    class="services-one__card "
                    data-wow-duration="1500ms"
                     style={{
    backgroundColor: "#181823",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "25px",
  }}
                  >
                    <span class="services-one__card__icon">
                      <i class="icon-spiral-flower"></i> </span
                    >
                    <div class="services-one__card__content">
                      <div  class="services-one__card__text-box">
                        <h3 style={{fontSize:"2rem"}} class="services-one__card__title">
                         Level 4 Business
                        </h3>
                        <p class="services-one__card__text">
                          {b4} USDT
                        </p>
                      </div>
                    </div>
                  </div>
                
                 <div   
                    class="services-one__card "
                    data-wow-duration="1500ms"
                     style={{
    backgroundColor: "#181823",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "25px",
  }}
                  >
                    <span class="services-one__card__icon">
                      <i class="icon-spiral-flower"></i> </span
                    >
                    <div class="services-one__card__content">
                      <div  class="services-one__card__text-box">
                        <h3 style={{fontSize:"2rem"}} class="services-one__card__title">
                         Level 5 Business
                        </h3>
                        <p class="services-one__card__text">
                          {b5} USDT
                        </p>
                      </div>
                    </div>
                  </div>
                   <div 
                    class="services-one__card "
                    data-wow-duration="1500ms"
                     style={{
    backgroundColor: "#181823",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "25px",
  }}
                  >
                    <span class="services-one__card__icon">
                      <i class="icon-spiral-flower"></i> </span
                    >
                    <div class="services-one__card__content">
                      <div  class="services-one__card__text-box">
                        <h3 style={{fontSize:"2rem"}} class="services-one__card__title">
                         Referlink
                        </h3>
                        <p class="services-one__card__text">
                           {referlink}
                        <a href="#">
                          <button>
                            <img
                              src="copy.png"
                              width={"15px"}
                              onClick={() => {
                                navigator.clipboard.writeText(referlink);
                              }}
                            />
                            </button>{" "}
                        </a>
                        </p>
                      </div>
                    </div>
                  </div>
                
                 <div 
                    class="services-one__card "
                    data-wow-duration="1500ms"
                     style={{
    backgroundColor: "#181823",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "25px",
  }}
                  >
                    <span class="services-one__card__icon">
                      <i class="icon-spiral-flower"></i> </span
                    >
                    <div class="services-one__card__content">
                      <div  class="services-one__card__text-box">
                        <h3 style={{fontSize:"2rem"}} class="services-one__card__title">
                         My Refer
                        </h3>
                        <p class="services-one__card__text">
                           {refer}
                        </p>
                      </div>
                    </div>
                  </div>
                
                 <div 
                    class="services-one__card "
                    data-wow-duration="1500ms"
                     style={{
    backgroundColor: "#181823",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "25px",
  }}
                  >
                    <span class="services-one__card__icon">
                      <i class="icon-spiral-flower"></i> </span
                    >
                    <div class="services-one__card__content">
                      <div  class="services-one__card__text-box">
                        <h3 style={{fontSize:"2rem"}} class="services-one__card__title">
                         My Account
                        </h3>
                        <p class="services-one__card__text">
                          {a1}
                        </p>
                      </div>
                    </div>
                  </div>
                
                
                

                
                
                
                  

                  </div>
                  </div>
                  </div>
                  </div>
                  </div>
                  </section>

     

      <br></br>
    </div>
  );
}

export default App;
